import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
// import { RefreshRemoteComponent } from './refresh-remote/refresh-remote.component';
// import { SurveysActionsComponent } from './surveys-actions/surveys-actions.component';
// import {GenericListModule} from '../generic-reference-list-list/generic-reference-list-list.module';
// import {SurveysListComponent} from './surveys-list.component';
// import {LoadingDirectiveModule} from '../loading-directive/loading-directive.module';
// import {MatButtonModule} from '@angular/material/button';
// import {MatIconModule} from '@angular/material/icon';
// import {RouterModule} from '@angular/router';
// import {MatTooltipModule} from '@angular/material/tooltip';
// import {SurveysSelectorModule} from '../surveys-selector/surveys-selector.module';
// import {TranslateModule} from '@ngx-translate/core';
// import {DxDataGridModule, DxPopupModule} from 'devextreme-angular';
// import {UrlPlaceholderModule} from '../url-placeholder/url-placeholder.module';
// import {NewSurveyPopupModule} from '../new-survey-popup/new-survey-popup.module';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    // GenericListModule,
    // LoadingDirectiveModule,
    // MatButtonModule,
    // MatIconModule,
    // RouterModule,
    // MatTooltipModule,
    // SurveysSelectorModule,
    // TranslateModule,
    // DxPopupModule,
    // DxDataGridModule,
    // UrlPlaceholderModule,
    // NewSurveyPopupModule,
  ],
  exports: [
    // SurveysListComponent,
  ]
})
export class SurveysListModule {

}
